//  [REDUCER][TYPE]
import { typeCreatorV2 } from '../../utils/common';

export const SET_MODAL_VISIBILITY: string = typeCreatorV2(
  'ModalReducer',
  'SetModalVisibility'
);

export enum ModalIDs {
  TOAST = 1,
  MODAL_DASHBOARD_ADD_GRAPH = 2,
  MODAL_FIXED_ESTABLISHMENT = 3,
  MODAL_IDENTIFICATION_IN_OTHER_EU_COUNTRIES = 4,
  MODAL_PREVIOUS_USE_OF_SPECIAL_SCHEMES = 5,
  MODAL_ADMIN_RESPONSE = 6,
  MODAL_ADD_APPLICANT = 7,
  MODAL_ADD_EDIT_NOTIFICATION = 8,
  MODAL_ADD_VAT_RETURN = 9,
  MODAL_ADD_SUPPLY_FROM_MEMBER_STATE_OF_IDENTIFICATION = 10,
  MODAL_ADD_SUPPLY_FROM_FIXED_ESTABLISHMENTS = 11,
  MODAL_ADD_VAT_RETURN_CORRECTIONS = 12,
  MODAL_CONFIRM_FINAL_SUBMIT = 13,
  MODAL_SESSION_EXPIRED = 14,
  MODAL_ADD_VAT_RETURN_PAYMENT = 15,
  MODAL_UPDATE_PAYMENT_INFO_REFERENCE = 16,
  MODAL_MESSAGE_OUTGOING_VIEW = 17,
  MODAL_MESSAGE_INCOMING_VIEW = 18,
  CONFIRMATION_MODAL = 19,
  EXCLUDE_REGISTRATION_CONFIRM_MODAL = 20,
  UPDATE_REGISTRATION_CONFIRM_MODAL = 21,
  MODAL_VAT_RETURN_REMINDER_XML_VIEW = 22,
  MODAL_PAYMENT_REMINDER_XML_VIEW = 23,
  MODAL_REGISTRATION_RECEIVED_VIEW = 24,
  MODAL_NOTIFICATION_VIEW = 25,
  MODAL_UPDATE_REIMBURSE_INFO = 26,
  MODAL_VAT_RETURN_RECEIVED_XML_VIEW = 27,
  MODAL_VAT_RETURN_RECEIVED_DETAILS_VIEW = 28,
  MODAL_PAYMENTS_RECEIVED_XML_VIEW = 29,
  MODAL_UPDATE_REIMBURSE_INFO_MSCON = 30,
  MODAL_MATCH_CENTRAL_BANK_PAYMENT = 31,
  MODAL_CENTRAL_BANK_PAYMENT_ERROR = 32,
  MODAL_EDIT_VAT_RATE = 33,
  MODAL_ADD_VAT_RATE = 34,
}
